import fetch from './fetch';
import EndPoints from '../data/EndPoints';
import Methods from '../data/Methods';

export default (companyId, year) => {
	const headers = { 'content-type': 'application/json' };
	return fetch(
		Methods.POST,
		`${EndPoints.COMPANIES_INVOICE_CONCEPTS_ARCHIVE.replace(':id', companyId)}?year=${year}`,
		null,
		headers,
		true
	);
};
